import StickerType from "@/domains/Stickers/StickerType";
import StickerTypesDAO from "@/domains/Stickers/StickerTypesDAO";
import Core from "@/core/Core";
import Dictionary from "@/core/types/Dictionary";

class StickerTypesService {

	/**
	 * Кеш типов стикеров. Наполняется из Dictionaries общим эндпоинтом.
	 * reactive — чтобы потребители перерисовывались, когда словарь долетит после логина.
	 */
	static stickerTypes = reactive(new Dictionary<number, StickerType>());

	static async get(
    params: Parameters<typeof StickerTypesDAO.get>[0]
  ): Promise<StickerType | null> {
		const response = await StickerTypesDAO.get(params);

		if (response.ok) {
			return StickerType.fromServer(response.data);
		}

		Core.showNotification.error('Ошибка при получении стикера');
		return null;
	}

	/**
	 * Получение списка StickerTypes
	 *
	 * @param setInDictionaries - костыль, чтобы значение в справочнике поменялось
	 */
	static async getList(setInDictionaries: boolean = false): Promise<StickerType[]> {
		const response = await StickerTypesDAO.getList();

		if (!response.ok) {
			Core.showNotification.error('Ошибка при получении стикеров');
			return [];
		}

		const result = Core.utils.hydrateArray(response.data, StickerType.fromServer)

		if (setInDictionaries) {
			this.stickerTypes.reset(result);
		}

		return result;
	}

	static async add(stickerTypes: StickerType[]): Promise<boolean> {
		const response = await StickerTypesDAO.add(stickerTypes);
		const successMessage = stickerTypes.length === 1 ? 'Стикер успешно создан' : 'Стикеры успешно созданы';

		if (response.ok) {
			Core.showNotification.success(successMessage);
			return true;
		}

		Core.showNotification.error('При добавлении возникла ошибка');
		return false;
	}

	static async update(stickerTypes: StickerType[]): Promise<boolean> {
		const response = await StickerTypesDAO.update(stickerTypes);
		const successMessage = stickerTypes.length === 1 ? 'Стикер успешно изменен' : 'Стикеры успешно изменены';

		if (response.ok) {
			Core.showNotification.success(successMessage);
			return true;
		}

		Core.showNotification.error('При обновлении возникла ошибка');
		return false;
	}

	static async delete(stickerType: StickerType, reasonText: string): Promise<boolean> {
		const response = await StickerTypesDAO.delete(stickerType, reasonText);

		if (response.ok) {
			Core.showNotification.success('Стикер успешно удален');
			return true;
		}

		Core.showNotification.error('При удалении возникла ошибка');
		return false;
	}
}

export default StickerTypesService;
